import { cn } from '@/lib/utils';

interface Props {
  title: string;
  selected: boolean;
  onClick: () => void;
}
export default function TheoryTabButton({ title, selected, onClick }: Props) {
  return (
    <button
      onClick={onClick}
      className={cn(
        'typo-18 desktop:typo-22 h-full w-full cursor-pointer rounded-lg',
        selected
          ? 'bg-main-yellow text-level-2 font-bold'
          : 'border-stroke-white text-font-grayblue border font-semibold',
      )}
    >
      {title}
    </button>
  );
}
